// The season list in the header is fetched once and is not refreshed when season settings are saved
// elsewhere (e.g. Evaluation Settings), so a row from it can carry stale flags such as AllowPrescreen.
// Overlay the season's current settings on the row before it becomes the selected season.
// Falls back to the row if the settings cannot be loaded.
export const loadCurrentSeason = async (row, fetchSettings) => {
  try {
    const res = await fetchSettings();
    if (res && res.data && !res.data.error) {
      return { ...row, ...res.data };
    }
  } catch (err) {
    // keep the list row
  }
  return row;
};
